'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import UILink from 'UIComponents/link/UILink';
export const SuiteTileCalculatorAnchorLink = ({
  productLevel
}) => {
  const handleClick = () => {
    document.querySelector(`#suite-calculator-${productLevel}-button`).click();
    document.querySelector('#calculator').scrollIntoView({
      behavior: 'smooth'
    });
    getUsageTracker().track('scrollInteraction', {
      name: 'crm-suite-tile',
      action: 'clicked calculate your price',
      edition: productLevel.toLowerCase()
    });
  };

  return /*#__PURE__*/_jsx(UILink, {
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.planBuilder.productPages.calculateYourPrice"
    })
  });
};